import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Basic' },
    { value: 2, label: 'HMAC SHA-256' },
    { value: 3, label: 'OAuth2' },
  ],
});
